var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('r-icon',{attrs:{"icon":_vm.icon,"size":_vm.size,"fill":_vm.fill}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }